export const LADDER_LIST_REQUEST = 'LADDER_LIST_REQUEST'
export const LADDER_LIST_SUCCESS = 'LADDER_LIST_SUCCESS'
export const LADDER_LIST_FAIL = 'LADDER_LIST_FAIL'
export const LADDER_LIST_RESET = 'LADDER_LIST_RESET'

export const LADDER_ADMIN_LIST_REQUEST = 'LADDER_ADMIN_LIST_REQUEST'
export const LADDER_ADMIN_LIST_SUCCESS = 'LADDER_ADMIN_LIST_SUCCESS'
export const LADDER_ADMIN_LIST_FAIL = 'LADDER_ADMIN_LIST_FAIL'
export const LADDER_ADMIN_LIST_RESET = 'LADDER_ADMIN_LIST_RESET'

export const LADDER_DETAILS_REQUEST = 'LADDER_DETAILS_REQUEST'
export const LADDER_DETAILS_SUCCESS = 'LADDER_DETAILS_SUCCESS'
export const LADDER_DETAILS_FAIL = 'LADDER_DETAILS_FAIL'
export const LADDER_DETAILS_RESET = 'LADDER_DETAILS_RESET'

export const LADDER_DELETE_REQUEST = 'LADDER_DELETE_REQUEST'
export const LADDER_DELETE_SUCCESS = 'LADDER_DELETE_SUCCESS'
export const LADDER_DELETE_FAIL = 'LADDER_DELETE_FAIL'
export const LADDER_DELETE_RESET = 'LADDER_DELETE_RESET'

export const LADDER_CREATE_REQUEST = 'LADDER_CREATE_REQUEST'
export const LADDER_CREATE_SUCCESS = 'LADDER_CREATE_SUCCESS'
export const LADDER_CREATE_FAIL = 'LADDER_CREATE_FAIL'
export const LADDER_CREATE_RESET = 'LADDER_CREATE_RESET'

export const LADDER_UPDATE_REQUEST = 'LADDER_UPDATE_REQUEST'
export const LADDER_UPDATE_SUCCESS = 'LADDER_UPDATE_SUCCESS'
export const LADDER_UPDATE_FAIL = 'LADDER_UPDATE_FAIL'
export const LADDER_UPDATE_RESET = 'LADDER_UPDATE_RESET'

export const LADDER_UPDATE_ENABLED_REQUEST = 'LADDER_UPDATE_ENABLED_REQUEST'
export const LADDER_UPDATE_ENABLED_SUCCESS = 'LADDER_UPDATE_ENABLED_SUCCESS'
export const LADDER_UPDATE_ENABLED_FAIL = 'LADDER_UPDATE_ENABLED_FAIL'
export const LADDER_UPDATE_ENABLED_RESET = 'LADDER_UPDATE_ENABLED_RESET'

export const LADDER_BULK_CREATE_REQUEST = 'LADDER_BULK_CREATE_REQUEST'
export const LADDER_BULK_CREATE_SUCCESS = 'LADDER_BULK_CREATE_SUCCESS'
export const LADDER_BULK_CREATE_FAIL = 'LADDER_BULK_CREATE_FAIL'
export const LADDER_BULK_CREATE_RESET = 'LADDER_BULK_CREATE_RESET'